import React, { useState } from 'react';
import { ChevronLeft, QrCode } from 'lucide-react';
type JoinProjectScreenProps = {
  onBack: () => void;
};
export function JoinProjectScreen({
  onBack
}: JoinProjectScreenProps) {
  const [projectCode, setProjectCode] = useState('');
  const [joined, setJoined] = useState(false);
  return <section className="flex h-full flex-col overflow-y-auto px-4 pb-5 pt-2 text-white" data-id="element-252" data-mp="21ekjino2zjq8">
      <button onClick={onBack} className="flex w-fit items-center rounded-full bg-[#5b5268]/85 px-2 py-1 text-[10px]" data-id="element-253" data-mp="1wf824ifzb4v1">
        <ChevronLeft className="h-3.5 w-3.5" data-id="element-254" data-mp="1rmwyb4i4ayx7" />
        Back
      </button>

      <div className="mx-auto mt-9 flex w-full max-w-[270px] flex-1 flex-col text-center" data-id="element-255" data-mp="1nluxij8jyet4">
        <span className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-[#5b5268]/90 text-[#ffe054] shadow-sm" data-id="element-256" data-mp="1injpme1tiedj">
          <QrCode className="h-8 w-8" aria-hidden="true" data-id="element-257" data-mp="1dn5euo8u0qbt" />
        </span>
        <h1 className="mt-4 text-lg font-bold" data-id="element-258" data-mp="18pdpo1zknibb">Join a project</h1>
        <p className="mt-1 text-[10px] leading-relaxed text-white/80" data-id="element-259" data-mp="18r6x3ji0e6kd">Enter the project code shared by your teacher or facilitator.</p>

        {joined ? <div className="mt-6 rounded-md bg-white/15 px-4 py-4 text-left" data-id="element-260" data-mp="235m4b2wcgbd9">
            <p className="text-xs font-bold" data-id="element-261" data-mp="1ofwl7soapmop">You’ve joined the project.</p>
            <p className="mt-1 text-[10px] text-white/80" data-id="element-262" data-mp="1odtpqt4dj1cl">Your project activities will now appear in your account.</p>
          </div> : <form className="mt-6 text-left" onSubmit={event => {
        event.preventDefault();
        setJoined(true);
      }} data-id="element-263" data-mp="2h5dcgn06ixjc">
            <label className="block text-[10px] font-semibold" htmlFor="project-code" data-id="element-264" data-mp="276nwizrufn5q">Project code</label>
            <input id="project-code" required value={projectCode} onChange={event => setProjectCode(event.target.value.toUpperCase())} placeholder="e.g. RGT-2048" className="mt-1 h-10 w-full rounded-md bg-[#5b5268]/90 px-3 text-center text-xs font-bold tracking-[0.18em] text-white placeholder:font-normal placeholder:tracking-normal placeholder:text-white/45 outline-none focus:ring-2 focus:ring-white/70" data-id="element-265" data-mp="2c4fvgdqwo9jf" />
            <button type="submit" className="mt-3 h-10 w-full rounded-md bg-white text-xs font-extrabold text-[#413946] active:scale-[.98]" data-id="element-266" data-mp="2tlw8xp8lqvt2">
              JOIN PROJECT
            </button>
          </form>}
      </div>
    </section>;
}